import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  blurredBackdrop: {
    backdropFilter: 'blur(6px)',
    backgroundColor: 'rgb(19, 30, 64, 0.6)',
  },
  modal: {
    borderRadius: theme.misc.borderRadius,
    boxShadow: theme.customShadows.shadow3,
    maxWidth: '100%',
    width: props => props && props.maxWidth,
    [theme.breakpoints.down('xs')]: {
      '& > .MuiDialogActions-root': {
        justifyContent: props => props.fullScreenOnMobile && 'center',
      },
      margin: props => props && !props.fullScreenOnMobile && theme.spacing(2),
    },
  },
}));

export default useStyles;
